export default "__VITE_ASSET___S_mUlC5__"